import { render, staticRenderFns } from "./savedQueries.vue?vue&type=template&id=14afde1f&scoped=true&"
import script from "./savedQueries.vue?vue&type=script&lang=js&"
export * from "./savedQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14afde1f",
  null
  
)

export default component.exports